/**
 * P4: where the pin points, as a CSS path of tag + :nth-child only. No ids,
 * classes or attribute values: those can carry customer data (a tenant slug,
 * a price). The last twelve steps are plenty to find the spot again.
 *
 * Mirrors backend/meldingen/schemas.py PIN_SELECTOR: tag [a-z][a-z0-9]*,
 * 1-4 digit index, at most 12 steps, at most 400 characters. When the element
 * cannot be written that way the answer is null (no pin), never a selector
 * the backend would refuse.
 */
const MAX_STAPPEN = 12;
const MAX_LENGTE = 400;
const MAX_INDEX = 9999;

export function pinSelector(el: Element, stop: Element): string | null {
  const stappen: string[] = [];
  let e: Element = el;
  while (e !== stop) {
    const ouder: Element | null = e.parentElement;
    if (!ouder) return null; // not inside `stop`
    const tag = e.tagName.toLowerCase();
    // Same tag rule as Qontrol's PIN_SELECTOR (deel 03): a custom element (my-el) would be refused there.
    if (!/^[a-z][a-z0-9]*$/.test(tag)) return null;
    const nr = Array.prototype.indexOf.call(ouder.children, e) + 1;
    if (nr > MAX_INDEX) return null;
    stappen.unshift(`${tag}:nth-child(${nr})`);
    e = ouder;
  }
  if (stappen.length === 0) return null;
  const selector = stappen.slice(-MAX_STAPPEN).join(' > ');
  return selector.length <= MAX_LENGTE ? selector : null;
}

function bevat(r: DOMRect, x: number, y: number): boolean {
  return r.width > 0 && r.height > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
}

/**
 * The deepest element under a viewport point. By geometry, not
 * document.elementsFromPoint: an open Radix dialog puts pointer-events:none on
 * <body>, and elementsFromPoint then skips the whole page.
 */
export function elementOnder(x: number, y: number, root: Element): Element | null {
  let beste: Element | null = null;
  let huidig: Element = root;
  // ponytail: 200 levels is deeper than any page here; it only bounds the loop.
  for (let diepte = 0; diepte < 200; diepte += 1) {
    const kind = Array.from(huidig.children).find((k) => bevat(k.getBoundingClientRect(), x, y));
    if (!kind) return beste;
    beste = kind;
    huidig = kind;
  }
  return beste;
}
